module.exports = __webpack_public_path__ + "static/media/web p5.10ac47d0.png";